// extracted by mini-css-extract-plugin
export default {"leftSide":"PricingItem_leftSide__IO6gu","rightSide":"PricingItem_rightSide__74XU1","label":"PricingItem_label__Ar7bS","error":"PricingItem_error__cynJL"};